import { useState } from "react"
import { createPortal } from "react-dom"
import { FaTimes, FaPlay } from "react-icons/fa"
import styled from "styled-components"
import { Button, FormField, FullScreenLoadingCover, Modal, SelectDropdown, useForm } from "@prosolve/common-components-ui"
import useDataJobs from "../../dataHooks/useDataJobs"

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 420px;
  max-width: calc(100vw - 80px);
`

const RowGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const MutedText = styled.div`
  color: ${({ theme }) => theme.colors.lightText};
  font-size: 13px;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 10px;
`

export default ({
  onClose
}) => {
  const [method, setMethod] = useState()

  const { isLoading, testTask, testTaskPost, fetchTestTask, fetchTestTaskPost } = useDataJobs()

  const formData = useForm({
    requiredFields: [],
    optionalFields: ['duration','response'],
    initData: {
      timeout: '3000',
      duration: '300',
      response: `{ "status": true, "message": "test response" }`
    }
  })

  const onConfirm = async () => {
    const isPost = method === 'post'
    const fn = (isPost ? fetchTestTaskPost : fetchTestTask)

    await fn(formData.values)

    console.log(isPost ? testTaskPost : testTask)
  }

  return createPortal(
    <Modal
      title='Test Task'
      isAutoHeight={true}
      isAutoWidth={true}
      onClose={onClose}
      footer={(
        <ButtonsContainer>
          <Button onClick={onClose}>
            <RowGroup>
              <FaTimes />
              Cancel
            </RowGroup>
          </Button>
          <Button $colored={true} onClick={onConfirm}>
            <RowGroup>
              <FaPlay />
              Run
            </RowGroup>
          </Button>
        </ButtonsContainer>
      )}
    >
      <ModalContainer>
        <div>Run Test Task</div>
        <MutedText>This is an empty task with configurable returns and timeouts to test if jobs are running correctly.</MutedText>
        <div>Method:</div>
        <SelectDropdown
          type='select'
          value='get'
          width='200px'
          onChange={setMethod}
          options={[
            { text: 'GET', value: 'get' },
            { text: 'POST', value: 'post' },
          ]}
        />

        <div>Duration (milliseconds):</div>
        <FormField
          fieldId='duration'
          formData={formData}
          type='number'
        />

        <div>Timeout (milliseconds):</div>
        <FormField
          fieldId='timeout'
          formData={formData}
          type='number'
        />

        <div>Response:</div>
        <FormField
          fieldId='response'
          formData={formData}
          type='text'
        />

        <div>Reject Reponse?</div>
        <FormField
          fieldId='isReject'
          formData={formData}
          type='checkbox'
        />
      </ModalContainer>

      {isLoading &&
        <FullScreenLoadingCover />
      }
    </Modal>,
    document.body
  )
}
